import { render, staticRenderFns } from "./CommentsAddon.vue?vue&type=template&id=7c13ccc4&scoped=true"
import script from "./CommentsAddon.vue?vue&type=script&lang=js"
export * from "./CommentsAddon.vue?vue&type=script&lang=js"
import style0 from "./CommentsAddon.vue?vue&type=style&index=0&id=7c13ccc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13ccc4",
  null
  
)

export default component.exports